'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var googleImagesApiMaxPixels = 2000;
var googleImagesApiUrlPattern = /^https?:\/\/(.+)\.(googleusercontent|ggpht)\.com\/(.+)$/;

var wixMediaPlatformMaxPixels = 5100; // Actually, width*height must be <= (5100)^2
var wixMediaPlatformUrlPattern = /^https?:\/\/(media\.wixapps\.net|.+\.wixmp\.com)\/(.+)\/images\/(.+)\/$/;
var wixMediaManagerUrlPattern = /^https?:\/\/static\.wixstatic\.com\/media\/(.+)$/;

// File should probably be renamed to something like ImageServiceUtils (it's not just GAE now)
exports.default = {

    /**
     * @param size  The bigger side of the image (eg, if picture box is 200px x 100px, give 200). 0 means max size.
     */
    getImageUrl: function getImageUrl() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$url = _ref.url,
            url = _ref$url === undefined ? null : _ref$url,
            _ref$size = _ref.size,
            size = _ref$size === undefined ? 0 : _ref$size;

        if (!url) {
            return null;
        }

        var extension = url.match(/\.[0-9A-z]+$/) || '.jpg';

        if (googleImagesApiUrlPattern.test(url)) {
            return url + '=s' + (size >= 0 && size <= googleImagesApiMaxPixels ? size : 0);
        }

        if (wixMediaManagerUrlPattern.test(url)) {
            return size > 0 && size <= wixMediaPlatformMaxPixels ? url + '/v1/fill/w_' + size + ',h_' + size + '/file' + extension : url;
        }

        if (wixMediaPlatformUrlPattern.test(url)) {
            return size > 0 && size <= wixMediaPlatformMaxPixels ? url + 'v1/fill/w_' + size + ',h_' + size + '/file' + extension : url;
        }

        return url;
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/GaeImageUtils.js
// module id = 998
// module chunks = 0